import { render, staticRenderFns } from "./finishTask.vue?vue&type=template&id=2f6befae&scoped=true&"
import script from "./finishTask.vue?vue&type=script&lang=js&"
export * from "./finishTask.vue?vue&type=script&lang=js&"
import style0 from "./finishTask.vue?vue&type=style&index=0&id=2f6befae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6befae",
  null
  
)

export default component.exports